export default __webpack_public_path__ + "static/media/cross.0be2a9a0.svg";